import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { OurproductServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Product Master section
 */
const useListOurproduct = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ["ourproduct-list", page_no],
    OurproductServices.ourproductList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};
const useAddOurproduct = (onSuccess, onError = onDefaultError) => {
  return useMutation(OurproductServices.addOurproduct, {
    onSuccess,
    onError,
  });
};
const useUpdateOurproduct = (onSuccess, onError = onDefaultError) => {
  return useMutation(OurproductServices.updateOurproduct, {
    onSuccess,
    onError,
  });
};
const useViewOurproduct = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "ourproduct-view",
    () => OurproductServices.viewOurproduct({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useOurproductDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(OurproductServices.deleteOurproduct, {
    onSuccess,
    onError,
  });
};
const useOurproductStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(OurproductServices.updateStatusOurproduct, {
    onSuccess,
    onError,
  });
};
export {
  useListOurproduct,
  useAddOurproduct,
  useUpdateOurproduct,
  useViewOurproduct,
  useOurproductDelete,
  useOurproductStatusChange,
};
